"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Allowed parameters for a PropertyShape
 */
exports.default = {
    deactivated: true,
    severity: true,
    message: true,
    class: true,
    datatype: true,
    nodeKind: true,
    minExclusive: true,
    minInclusive: true,
    maxExclusive: true,
    maxInclusive: true,
    minLength: true,
    maxLength: true,
    pattern: true,
    flags: true,
    languageIn: true,
    uniqueLang: true,
    equals: true,
    disjoint: true,
    lessThan: true,
    lessThanOrEquals: true,
    qualifiedValueShape: true,
    qualifiedMinCount: true,
    qualifiedMaxCount: true,
    qualifiedValueShapesDisjoint: true,
    closed: true,
    ignoredProperties: true,
    hasValue: true,
    in: true,
    // This is here so that we can exract it from alts
    node: true,
};
